import { CenterFlexColumn } from "styles/layout";
import { MatchViewerH2HTeam } from "./MatchViewerH2HTeam";
import { Score, BestOf, ByeTBD, TeamsContainer, TeamContainer } from "./styles";
import { Match, matchCompleteByByes } from "model/Match/Match";
import { matchHasStarted } from "model/Match/MatchStatus";
import { getMultiSetFormatString } from "model/Match/MatchFormat";
import {
  getRosterDriverIds,
  getRosterId,
  isPlaceholderRoster,
} from "model/Roster/Roster";
import { getRosterDisplayScore } from "model/Match/MatchScore";

interface Props {
  match: Match;
  tournamentId: string;
}

export const MatchViewerH2HTeams = ({ match, tournamentId }: Props) => {
  const completeByByes = matchCompleteByByes(match.teams.rosters);
  const showScores = matchHasStarted(match) && !completeByByes;

  const rosterScope = match.teams.scope;
  const rosterOne = match.teams.rosters.at(0);
  const rosterOneId = !!rosterOne ? getRosterId(rosterOne) : undefined;
  const rosterOneDriverIds = !!rosterOne
    ? getRosterDriverIds(rosterOne, rosterScope)
    : undefined;
  const rosterOneScore = !!rosterOneId
    ? getRosterDisplayScore(match, rosterOneId)
    : undefined;

  const rosterTwo = match.teams.rosters.at(1);
  const rosterTwoId = !!rosterTwo ? getRosterId(rosterTwo) : undefined;
  const rosterTwoDriverIds = !!rosterTwo
    ? getRosterDriverIds(rosterTwo, rosterScope)
    : undefined;
  const rosterTwoScore = !!rosterTwoId
    ? getRosterDisplayScore(match, rosterTwoId)
    : undefined;

  return (
    <TeamsContainer>
      <TeamContainer>
        {!rosterOne || isPlaceholderRoster(rosterOne) ? (
          <ByeTBD>{!!rosterOne ? rosterOne : "TBD"}</ByeTBD>
        ) : (
          <MatchViewerH2HTeam
            matchId={match.id}
            rosterId={rosterOneId!}
            driverIds={rosterOneDriverIds ?? []}
            tournamentId={tournamentId}
          />
        )}
      </TeamContainer>
      <CenterFlexColumn>
        {showScores ? (
          <Score>
            {rosterOneScore ?? "?"} - {rosterTwoScore ?? "?"}
          </Score>
        ) : (
          !completeByByes && <span>vs</span>
        )}
        {match.format.type !== "Single" && (
          <BestOf>{getMultiSetFormatString(match.format)}</BestOf>
        )}
      </CenterFlexColumn>
      <TeamContainer>
        {!rosterTwo || isPlaceholderRoster(rosterTwo) ? (
          <ByeTBD>{!!rosterTwo ? rosterTwo : "TBD"}</ByeTBD>
        ) : (
          <MatchViewerH2HTeam
            matchId={match.id}
            rosterId={rosterTwoId!}
            driverIds={rosterTwoDriverIds ?? []}
            tournamentId={tournamentId}
          />
        )}
      </TeamContainer>
    </TeamsContainer>
  );
};
